<template>
  <div id="choose-product" class="tw-w-full tw-px-4 md:tw-px-0 md:tw-w-10/12 tw-mt-12 tw-mb-6 tw-flex tw-flex-wrap tw-justify-between tw-pb-5">
    <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
            <v-form v-model="isValid">
              <div class="tw-w-full">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Which option below best describes you?</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <v-radio-group class="my-2 tw-px-0 md:tw-px-6" v-model="form.home_option" :rules="[v => !!v || 'Selection choice is required']" row>
                <v-radio label="Rent" :value="1" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Own" :value="2" class="tw-mt-0 md:tw-mt-5"></v-radio>
              </v-radio-group>
          </div>
          <div v-if="form.home_option === 2">
              <v-text-field
                    v-model="form.building_value"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="Enter the value of your building"
                    type="number"
                    :rules="[required('Building Value')]"
                ></v-text-field>
            </div>
            <!-- <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3"> -->
            <div>
                <v-text-field
                    v-model="form.house_items_value"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="Enter the value of your house items eg furniture, fridge"
                    type="number"
                    :rules="[required('Value of house items')]"
                ></v-text-field>
                <v-text-field
                    v-model="form.portable_items_value"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="Enter the value of your portable items eg laptop"
                    type="number"
                    :rules="[required('Value of portable items')]"
                ></v-text-field>
              </div>

              <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
                <v-btn block large
                       color="secondary"
                       class="my-3 "
                       @click="proceed"
                       :disabled="!isValid"
                >
                  {{ isValid ? 'Get Quote' : 'Check if all fields are filled' }}
                </v-btn>
              </v-card-actions>

            </v-form>
          </div>
  </div>
</template>

<script>
import validations from '@/utils/validations';
import axios from 'axios';

export default {
  name: 'StartDP',
  data() {
    return {
      ...validations,
      form: {
        building_value: '',
        house_items_value: '',
        portable_items_value: '',
        home_option: 'rent',
      },
      home_option: 'rent',
      isValid: false,
    };
  },
  methods: {
    setHomeOption() {
      if (this.form.home_option === 1) {
        this.home_option = 'rent';
      } else {
        this.home_option = 'own';
      }
    },
    proceed() {
      this.setHomeOption();
      const data = {
        building_value: this.form.building_value || 0,
        house_items_value: this.form.house_items_value || 0,
        portable_items_value: this.form.portable_items_value || 0,
        home_option: this.home_option,
      };
      axios.post('/customer/digital-quotation/domestic-package/quotes', data).then((response) => {
        this.$store.commit('rfq/setDPQuoteResponse', response.data);
        this.$root.$emit('proceed-to-dp-plan');
      });
    },
  },
};
</script>
